<template>
    <footer
        :class="['footer-data',
                 displayType === displayExtraSmall ? 'footer-data-xs' : '']"
    >
        <h2 class="sr-only">
            {{ $t("App.Footer.HiddenHeading") }}
        </h2>
        <div class="footer-logo">
            <img
                :src="traficomLogo"
                :alt="traficomLogoAlt"
            >
        </div>
        <div
            :class="['footer-content',
                     !displayLargeOrExtraLarge ? 'footer-content-m-s-xs' : '',
                     twoColumnsMobileFooter ? 'two-columns-mobile' : '',
                     displayType === displayExtraSmall ? 'footer-content-xs' : '']"
        >
            <div
                :class="['footer-text',
                         displayType === displayExtraSmall ? 'footer-text-xs' : '']"
            >
                {{ $t("App.Footer.Content") }}
            </div>
            <div
                :class="['footer-links',
                         !displayLargeOrExtraLarge ? 'footer-links-m-s-xs' : '']"
            >
                <a
                    class="open-modal-lisatietoa"
                    href="#"
                    @click="openModal('TietoaSivustosta')"
                    @keydown.enter="openModal('TietoaSivustosta')"
                >{{ infoText }}</a> <!-- TODO OKo: #22515 Kielitermit, ja linkkien kohteet -->
                <a
                    :href="saavutettavuusSelosteLink"
                    target="_blank"
                >
                    {{ saavutettavuusSelosteText }}
                    <img
                        class="footer-external-icon"
                        :src="externalLink"
                        :alt="externalLinkAlt"
                    >
                    <span class="visually-hidden">{{ linkOpensNewTabText }}</span>
                </a>
                <a
                    href="https://link.webropolsurveys.com/S/359E3AEB53C5A2D1"
                    target="_blank"
                >
                    {{ annaPalautettaText }}
                    <img
                        class="footer-external-icon"
                        :src="externalLink"
                        :alt="externalLinkAlt"
                    >
                    <span class="visually-hidden">{{ linkOpensNewTabText }}</span>
                </a>
                <a
                    class="open-modal-sivukartta"
                    href="#"
                    @click="openModal('Sivukartta')"
                    @keydown.enter="openModal('Sivukartta')"
                >{{ sivukarttaText }}</a>
            </div>
        </div>
    </footer>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"

    @Component
    export default class Footer extends Vue {
        get traficomLogo(): string {
            return this.$store.getters.contentServiceUrl + "/Content/images/Traficom-logo-footer-" + this.activeLang + ".svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get activeLang(): string {
            return this.$store.getters.activeLang
        }

        get traficomLogoAlt(): string | undefined {
            return this.$t("App.Footer.TraficomLogoAlt")
        }

        // ruutukoko
        get displayType(): string {
            return this.$store.getters.displayType
        }

        get displayLarge(): string {
            return this.$store.state.displayLarge
        }

        get displayExtraLarge(): string {
            return this.$store.state.displayExtraLarge
        }

        get displayMedium(): string {
            return this.$store.state.displayMedium
        }

        get displaySmall(): string {
            return this.$store.state.displaySmall
        }

        get displayExtraSmall(): string {
            return this.$store.state.displayExtraSmall
        }

        get displayLargeOrExtraLarge(): boolean {
            return this.displayType === this.displayExtraLarge || this.displayType === this.displayLarge
        }

        get twoColumnsMobileFooter(): boolean {
            return this.$store.getters.twoColumnsMobileFooter
        }

        get sivukarttaText(): string | undefined {
            return this.$t("App.Footer.Sivukartta")
        }

        get infoText(): string | undefined {
            return this.$t("App.Footer.TietoaSivustosta")
        }

        get annaPalautettaText(): string | undefined {
            return this.$t("App.Footer.AnnaPalautetta")
        }

        get saavutettavuusSelosteText(): string | undefined {
            return this.$t("App.Footer.SaavutettavuusSeloste")
        }

        get saavutettavuusSelosteLink(): string | undefined {
            switch (this.activeLang.toLowerCase()) {
                case "sv":
                    return "https://www.traficom.fi/sv/tillganglighetsutlatande-tietotraficom-kartor"
                case "en":
                    return "https://www.traficom.fi/en/accessibility-statement-tietotraficom-maps"
                case "fi":
                default:
                    return "https://www.traficom.fi/fi/tietotraficom-kartat-saavutettavuusseloste"
            }
        }

        get externalLink(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/linkki-external.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get externalLinkAlt(): string | undefined {
            return this.$t("App.Link.UlosJohtavaLinkki")
        }

        get linkOpensNewTabText(): string | undefined {
            return this.$t("App.Link.LinkOpensNewTab")
        }

        get modalValue(): string {
            return this.$store.getters.modalComponentName
        }

        @Watch("modalValue")
        handleModalCloses(newVal, oldVal) {
            if (oldVal === "TietoaSivustostaModal" && newVal === "") {
                (this.$el.querySelectorAll(".open-modal-lisatietoa")[0] as HTMLElement).focus()
            }
            else if (oldVal === "SivukarttaModal" && newVal === "") {
                (this.$el.querySelectorAll(".open-modal-sivukartta")[0] as HTMLElement).focus()
            }
        }

        openModal(type: string) {
            switch (type) {
                case "TietoaSivustosta":
                    this.$store.dispatch("setModalComponentName", "TietoaSivustostaModal")
                    break
                case "Sivukartta":
                    this.$store.dispatch("setModalComponentName", "SivukarttaModal")
                    break
                default:
                    break
            }
        }
    }
</script>

<style scoped>
    h2.sr-only {
        color: white;
    }

    .footer-data {
        display: flex;
        margin: 24px;
    }

    .footer-data-xs {
        flex-direction: column;
    }

    .footer-content {
        display: flex;
        max-width: 600px;
        margin-left: 60px;
    }

    .footer-content-m-s-xs {
        flex-direction: column;
    }

        .footer-content-m-s-xs.two-columns-mobile {
            flex-direction: row;
        }

    .footer-content-xs {
        margin-left: 0px;
    }

    .footer-logo img {
        width: 253px;
    }

    .footer-text {
        max-width: 18.75rem;
    }

    .footer-text-xs {
        margin-top: 20px;
    }

    .footer-links {
        max-width: 18.75rem;
        margin-left: 30px;
    }

    .footer-links-m-s-xs {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        margin-left: 0px;
    }

    .footer-content-m-s-xs.two-columns-mobile .footer-links-m-s-xs {
        margin-top: 0px;
        margin-left: 30px;
    }

    .footer-links a {
        display: flex;
        color: white;
        background: none;
        padding-bottom: 10px;
    }

        .footer-links a:hover {
            text-decoration: underline;
        }

        .footer-links a:focus {
            outline: 3px solid white;
            outline-offset: 2px;
        }

    .footer-external-icon {
        filter: brightness(0) invert(1);
        width: 1rem;
        margin-left: 5px;
    }
</style>
